import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "30",
  height: "30",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  class: "fillStroke",
  d: "M17 3.182H1v11.636h16V3.182Z",
  stroke: "#F59600",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "fillPath fillStroke",
  d: "M14.09 1H1v2.182h13.09V1ZM17 7.545h-5.09v2.91H17v-2.91Z",
  fill: "#F59600",
  stroke: "#F59600",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.727 9.364a.364.364 0 1 0 0-.728.364.364 0 0 0 0 .728Z",
  fill: "#3C3D40"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render };